module.exports = __webpack_public_path__ + "static/media/marker.21fdc572.svg";